var map = {
	"./site-logo-desktop-alt.svg": 51210,
	"./site-logo-desktop-footer.svg": 55208,
	"./site-logo-desktop.svg": 65036,
	"./site-logo-drawer-mobile.svg": 37714,
	"./site-logo-drawer.svg": 659,
	"./site-logo-mobile-drawer.svg": 9172,
	"./site-logo-mobile.svg": 93378,
	"./site-logo-sm.svg": 64192,
	"./site-logo-wrapper-mobile-scrolled.svg": 5021,
	"./site-logo-wrapper-mobile.svg": 27128,
	"./site-logo-wrapper-scrolled.svg": 58866,
	"./site-logo-wrapper.svg": 79805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37663;